<div class="container" [style]="'--corp-color-1: ' + corpColor">
    @for (opt of options; track opt.value; let idx = $index, e = $even) {
        <div class="option-card" (click)="select(opt)" 
            [class.selected]="opt.checked" 
            [class.disabled]="opt.disabled"
            [pTooltip]="opt.disabled ? opt.disabledTooltip : null"
            tooltipPosition="top" 
            tooltipStyleClass="cards-option-tooltip"
            >

            @if (multiple){
                <p-checkbox [(ngModel)]="opt.checked" [binary]="true" />
            }

            @if (opt.iconClass || opt.iconPath){
                <div class="icon">
                    @if (opt.iconClass){
                        <i [class]="opt.iconClass"></i>
                    }
                    @if (opt.iconPath){
                        <img [src]="opt.iconPath">
                    }
                </div>
            }
            <div>
                <h3>{{opt.title}}</h3>
                
                <div [innerHTML]="opt.description"></div>
                <div class="d-flex justify-content-between align-items-end">
                    <div *ngIf="opt.footer" class="footer" [innerHTML]="opt.footer"></div>
                    <div *ngIf="opt.disabled && opt.waitingList" class="text-end">
                        <button class="btn button-wait-list rounded"> <i class="fa fa-pencil"></i> {{'WAITINGLIST.joinGroupWaitingList' | translate}} </button>
                    </div>
                </div>


            </div>

        </div>
    }
</div>
